import { Icon, MenuItem } from "@blueprintjs/core"
import CustomTooltip from "components/Atoms/CustomTooltip"
import StaticSelector from "components/Atoms/StaticSelector"
import { useAllTimeSlotsSelectorQuery } from "generated/graphql"
import { get } from "lodash-es"
import React from "react"
import convertTime from "utils/convertTime"
const disableItem = (selectedItems, item) => {
  return (
    selectedItems && selectedItems.find(si => get(si, "id") === get(item, "id"))
  )
}
const TimeSlotSelector = ({ timeSlots, index, timeSlot, onCompleted }) => {
  const { data, loading, error } = useAllTimeSlotsSelectorQuery({
    onCompleted,
  })
  if (error) return null
  let allTimeSlots = get(data, "allTimeSlots", [])
  const from = convertTime(timeSlot.fromTime, ":", "ha")
  const to = convertTime(timeSlot.toTime, ":", "ha")
  const ts = timeSlots.map(ts => ts.timeSlot)
  return (
    <StaticSelector
      loading={loading}
      items={allTimeSlots || []}
      path={`timeSlots.${index}.timeSlot`}
      label={
        <div className="flex items-baseline">
          Time Slot
          <CustomTooltip
            className="vt-form-tooltip"
            content={from && to && `from ${from} to ${to}`}
            placement="top"
          >
            <Icon className="ml-2" icon="info-sign" iconSize={13} />
          </CustomTooltip>
        </div>
      }
      itemRenderer={(item, { handleClick, modifiers }) => {
        return (
          <MenuItem
            active={modifiers.active}
            key={item.id}
            onClick={handleClick}
            text={item.name}
            disabled={disableItem(ts, item)}
          />
        )
      }}
    />
  )
}

export default TimeSlotSelector
